module.exports = __webpack_public_path__ + "img/111ne.349687b8.svg";